import Enum from './Enum';

export const ZoneMapUsecaseLabelEnum = new Enum({
    AUTOSORT: 'AS',
    ROUTE_RESTRICTION: 'RR',
    PARKING: 'P'
});
